import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  buttonStyle: {
    margin: "5px 1rem 0 0",
    backgroundColor: "#ffffff",
    color: "#262626",
    border: "1px solid #D4D4D4",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },
  datePickerParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width:834px)": {
      display: "block",
    },
  },
  popOverCard: {
    "@media (max-width:992px)": {
      left: "250px !important",
    },
    "@media (max-width:600px)": {
      left: "18px !important",
    },
    "@media (max-width:360px)": {
      left: "0px !important",
    },
  },
  buttonsParent: {
    borderRight: "1px solid #F5F5F5",
    display: "flex",
    flexDirection: "column",
    padding: "0 10px 0 0",
    "@media (max-width:834px)": {
      borderRight: "none",
    },
  },
  datePickerParentDiv: {
    // padding: "10px 0 10px 0",
  },
  datePicker: {
    padding: "0 10px 0 10px",
  },
  
  dateButtons: {
    width: "auto",
    marginTop: "12px",
    transition: "0.5s",
    backgroundColor: "transparent",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#F5F5F5",
      color: "#262626",
    },
    color: "#000000",
    "@media (max-width:834px)": {
      backgroundColor: "#262626",
      color: "#F5F5F5",
    },
  },
  activeButton: {
    backgroundColor: "#000",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#000",
      color: "#fff",
    },
  },
  bottomButtonsParent: {
    borderTop: "1px solid #F5F5F5",
    paddingTop: "10px",
  },
  bottomButtons: {
    marginLeft: "15px",
  },
  cancelButton: {
    backgroundColor: "#F5F5F5",
    color: "#262626",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  applyButton: {
    backgroundColor: "#262626",
    width: "55%",
    "&:hover": {
      backgroundColor: "#262626",
    },
  },
  iconCalendar: {
    margin: "0 10px 0 0",
  },
}));

export default useStyles;
